import type { AdWidget } from './AdWidget';
import {
    BaseWidgetConfiguration,
    TimelineSlot,
    WidgetType,
    ZodBaseWidgetConfiguration,
} from '../types';
import { ZodGenericWidgetConfigurationDetails } from '../types';
import { z } from 'zod';

//TODO: Move these types and interfaces into class TS file

export interface AdObject {
    adbundleid: number;
    adbundlename: string;
    adid: number;
    adname: string;
    assetUrl?: string;
    asset_uuid: string;
    domRendered: boolean;
    /** String "booleans" representing ad play schedule */
    days: {
        monday: 'true' | 'false';
        tuesday: 'true' | 'false';
        wednesday: 'true' | 'false';
        thursday: 'true' | 'false';
        friday: 'true' | 'false';
        saturday: 'true' | 'false';
        sunday: 'true' | 'false';
    };
    /** number of seconds */
    duration: number;

    /**
     * (time format: 'hh:mm:ss')
     * @todo Newer TS could type as
     * `${number}${number}:${number}${number}:${number}${number}`
     */
    endtime: 'string';

    /** file type of this ad's asset */
    filetype?: string;
    jqWrapperElement?: JQuery<HTMLElement>;
    /** number of times ad has been played */

    //@todo: this is not optional anymore,
    // might have to create a new type when we get the object from the server
    playcount: number;
    saturation: number;
    /** (time format: 'hh:mm:ss') */
    starttime: string;
    videoElement?: HTMLVideoElement;
}

export type AdWidgetTimelineSlotParams = {
    ad: AdObject;
};

export type AdWidgetTimelineSlot = TimelineSlot<AdWidgetTimelineSlotParams, AdWidget>;

export const ZodAdWidgetConfigurationDetails = ZodGenericWidgetConfigurationDetails.extend({
    adbundles: z.nullable(z.string()),
});

export type AdWidgetConfigurationDetails = z.infer<typeof ZodAdWidgetConfigurationDetails>;

export interface AdWidgetConfiguration extends BaseWidgetConfiguration {
    type: WidgetType.AD;
    config: AdWidgetConfigurationDetails;
}

export const ZodAdWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.AD),
    config: ZodAdWidgetConfigurationDetails,
});

export type AdAssetInformation = {
    type: string; // mimetype
    name: string;
    uuid: string;
    arl: string;
};
